<template>
    <div>

        <b-overlay :show="loading && !!items.length" rounded="sm" class="h-100">

            <router-view name="feed" />

        </b-overlay>

    </div>
</template>



<script>
    export default {
        name: 'Feeds',
        inject: {
            parentComponent: {
                default: null,
            },
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                requestFeeds: this.$req('campaigns/feeds'),
            };
        },
        computed: {
            campaignId() {
                return this.parentComponent?.item?.id;
            },
            items() {
                return this.requestFeeds.getData() || [];
            },
            error() {
                return this.requestFeeds.getError();
            },
            loading() {
                return this.requestFeeds.getLoading();
            },
        },
        watch: {
            items() {
                this.$set(this.parentComponent.item, 'feeds', this.items);
            },
            loading() {
                this.$store.commit('campaigns/setLoading', { key: 'feeds', value: this.loading });
            },
            $route: {
                immediate: true,
                handler(to, from) {
                    if (to.name === 'CampaignsDetailsTabIndex' || !this.parentComponent.item.feeds) {
                        this.fetchData();
                    }
                },
            },
        },
        methods: {
            fetchData() {
                return this.requestFeeds.get({ urlParams: { campaignId: this.campaignId } }).catch(error => this.$toastr.error(error.message, this.$t('errorOccurred')));
            },
        },
    };
</script>
